import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createFolderActions } from './actions';
import { FolderActions, FolderState } from './types';

export const useFolderStore = create<FolderState & FolderActions>()(
    // persist(
    immer((set, get, store) => ({
        folders: [],
        loading: false,
        selectedFolder: null,
        loadingFolder: false,
        error: undefined,
        ...createFolderActions(set, get, store),
    })),
    // {
    //     name: 'folders',
    //     storage: createJSONStorage(() => ({
    //         async getItem(key: string) {
    //             const { indexedDbInstance } = useDexie();

    //             const entry = await indexedDbInstance.table('keyval').get(key);

    //             return entry ? entry.value : null;
    //         },
    //         async setItem(key: string, value: any) {
    //             const { indexedDbInstance } = useDexie();

    //             await indexedDbInstance.table('keyval').put({ key, value });
    //         },
    //         async removeItem(key: string) {
    //             const { indexedDbInstance } = useDexie();

    //             await indexedDbInstance.table('keyval').delete(key);
    //         },
    //     })),
    // },
    // ),
);
